<template>
  <div id="detail" class="full_layout detail" v-loading.fullscreen="loading" v-if="detailInfo!=null">
    <div class="breadcrumbANDsort">
      <div class="breadcrumb">
        <router-link :to="{path:'/'}">{{$t('Home')}}</router-link>
        <span>{{detailInfo.Title}}</span>
      </div>
    </div>
    <div class="productsDetail space_between">
      <card-swiper :imglist='imageList' :releaseType='detailInfo.ReleaseType' :presale='detailInfo.Presale' />
      <div class="detailText">
        <h2 class="h2 pointTitle">{{detailInfo.Title}}</h2>
        <div class="detailInfo">
          <div class="detailPrice space_between">
            <div id="pointsPrice"><span class="points">{{detailInfo.PointsScore}} {{$t('Points')}}  </span><span class="pointPrice" v-if="detailInfo.Price>0">+￥ {{detailInfo.Price.toLocaleString()}}</span></div>
            <div class="outOfStock" v-if="detailInfo.QuantitySold<=0&&detailInfo.ReleaseType!=1||detailInfo.Status<1">{{detailInfo.Status<=-2?$t('Unavailable'):$t('OutofStock')}}</div>
          </div>
          <div class="detailBtn space_between" v-if='(detailInfo.QuantitySold>0&&detailInfo.Status>0)'>
            <el-input-number v-model="quantitySold" @change="quantityChange" :min="1" :max="detailInfo.QuantitySold>=5?5:detailInfo.QuantitySold"></el-input-number>
            <!-- 用户已登录 -->
            <div class="detailBall" v-if="userInfo!=null">
              <el-button type="primary" @click="goToPay(detailInfo)" v-if="detailInfo.ReleaseType!=1&&detailInfo.Presale!=1">{{$t('RedeemNow')}}</el-button>
            </div>
            <!-- 用户未登录 -->
            <div class="detailBall" v-if="userInfo==null">
              <el-button type="primary" @click="tologin()" v-if="detailInfo.ReleaseType!=1&&detailInfo.Presale!=1">{{$t('RedeemNow')}}</el-button>
            </div>
          </div>
        </div>
        <div class="pack">
          <div>{{$t('PackageDetails')}}</div>
          <p class="explain_P" v-html="detailInfo.Explain"></p>
        </div>
      </div>
    </div>
    <div class="describe">
      <el-divider content-position="center">{{$t('ProductDescription')}}</el-divider>
      <div class="describeBox" v-html="detailInfo.Detail">
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo,numMulti} from "@/api/public";
import CardSwiper from "@/components/swiper/card";
export default {
  name: 'detail',
  components: { CardSwiper },
  inject: ['reload'],
  data() {
    return {
      loading: false,
      detailInfo: null,
      userInfo: getInfo(),
      quantitySold: 1,
      imageList: null,
      isId: 0,
      istype: false //判断是否需要面包屑
    }
  },
  filters: {
    setTime(val) {
      if (val != '' && val != undefined) {
        val = val.split(" ");
        val = val[0]
      }
      return val
    },
  },
  mounted() {
    this.$root.$on("closeDialog", (val, bol) => {
      this.userInfo = getInfo();
      this.$enumInfo.dislogType[val] = bol;
      if (this.userInfo != null) {
        this.reload();
      }
    })
  },
  created() {
    this.getPath();
    this.toCartBox()
  },
  watch: {
    '$route': 'getPath'
  },
  methods: {
    setPrice(num1,num2){
      return numMulti(num1,num2)
    },
    getPath() {
      this.istype = this.$route.query.type != 1 ? true : false;
      this.isId = this.$route.params.id;
      this.getDetail();
    },
    tologin() {
      this.$enumInfo.dislogType.login = true
    },
    getDetail() {
      let that = this;
      that.loading = true;
      let data = { Id: that.isId }
      if (that.userInfo != null) {
        data = { Id: that.isId, MemberId: that.userInfo._id }
      }
      that.$get(that.$interface.GetCommodityById, data).then(res => {
        if (res.Result != 0) {
          that.detailInfo = res.Data;
          document.title = res.Data.Title + that.$t('DAKA');
          let imglist = [];
          if (res.Data.ImgList != null || res.Data.ImgList.length > 0) {
            res.Data.ImgList.map(it => {
              imglist.push(it.Url)
            })
          } else {
            imglist.push(res.Data.TitImg)
          }
          that.imageList = imglist
        }
        that.loading = false;
      })
    },
    quantityChange() {

    },
    goToPay(obj) {
      let data = {
        Details: [{
          AdvancePrice: obj.AdvancePrice,
          Presale: obj.Presale,
          CommodityId: obj._id,
          CreateDate: obj.CreateDate,
          LowestPrice: obj.LowestPrice,
          Num: this.quantitySold,
          Price: obj.Price,
          PointsScore: obj.PointsScore,
          TitImg: obj.TitImg,
          Title: obj.Title,
          _id: obj._id,
          IsPoints:obj.IsPoints
        }]
      };
      window.sessionStorage.setItem('dakacheck', JSON.stringify(data))
      this.$router.push({ path: '/checkout' })
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/detail.css";



/*.h2:before {
  content: "即将上架";
}*/

</style>



// WEBPACK FOOTER //
// src/pages/point/item.vue